module.exports = __webpack_public_path__ + "img/facebook_sample_nice_icon.184230ca.svg";